import { useState, useEffect } from 'react';
import { useApi } from '../hooks/useApi';
import { fmtDate } from '../events/util';
import { resizeImage } from '../events/util';

const INK = '#9A9A9A';

export default function Galeria() {
  const api = useApi();
  const [albums, setAlbums] = useState([]);
  const [f, setF] = useState({ title: '', date: '', cover_url: null, drive_link: '' });
  const [editing, setEditing] = useState(null);
  const [galleryUrl, setGalleryUrl] = useState('');
  const [savedUrl, setSavedUrl] = useState(false);
  const load = () => api.get('/api/gallery').then(setAlbums).catch(() => {});
  useEffect(() => {
    load();
    api.get('/api/org').then(o => setGalleryUrl(o.gallery_url || '')).catch(() => {});
  }, []); // eslint-disable-line
  async function saveGalleryUrl() {
    try { await api.patch('/api/org', { gallery_url: galleryUrl }); setSavedUrl(true); setTimeout(() => setSavedUrl(false), 2000); }
    catch (e) { alert(e.message); }
  }

  const onCover = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    try { const url = await resizeImage(file, 1000, 0.8); setF(s => ({ ...s, cover_url: url })); } catch (err) { alert(err.message); }
  };
  async function create() {
    if (!f.title.trim()) { alert('Poné un título'); return; }
    try { await api.post('/api/gallery', f); setF({ title: '', date: '', cover_url: null, drive_link: '' }); load(); }
    catch (e) { alert(e.message); }
  }
  async function toggle(a) { try { await api.patch(`/api/gallery/${a.id}`, { visible: !a.visible }); load(); } catch (e) { alert(e.message); } }
  async function rm(id) { if (!window.confirm('¿Eliminar álbum?')) return; try { await api.del(`/api/gallery/${id}`); load(); } catch (e) { alert(e.message); } }

  return (
    <div className="lb-fade">
      <div className="lb-display" style={{ fontSize: 24, marginBottom: 18 }}>Galería</div>

      <div className="lb-card" style={{ padding: '18px 22px', marginBottom: 18, display: 'flex', gap: 10, alignItems: 'end', flexWrap: 'wrap' }}>
        <Field label="Link a todas las galerías"><input className="lb-input" style={{ minWidth: 320 }} value={galleryUrl} onChange={e => setGalleryUrl(e.target.value)} placeholder="https://drive.google.com/… o link al álbum completo" /></Field>
        <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={saveGalleryUrl}>Guardar link</button>
        {savedUrl && <span style={{ color: '#2ecc71', fontSize: 12 }}>Guardado ✓</span>}
      </div>

      <div className="lb-card" style={{ padding: '20px 22px', marginBottom: 22, display: 'grid', gridTemplateColumns: '1fr 160px 1.4fr auto', gap: 12, alignItems: 'end' }}>
        <Field label="Título"><input className="lb-input" value={f.title} onChange={e => setF({ ...f, title: e.target.value })} placeholder="Giuli Pozzetto" /></Field>
        <Field label="Fecha"><input className="lb-input" type="date" value={f.date} onChange={e => setF({ ...f, date: e.target.value })} /></Field>
        <Field label="Link de Google Drive"><input className="lb-input" value={f.drive_link} onChange={e => setF({ ...f, drive_link: e.target.value })} placeholder="https://drive.google.com/…" /></Field>
        <label className="lb-btn lb-btn--ghost lb-btn--sm" style={{ cursor: 'pointer' }}>{f.cover_url ? 'Portada ✓' : 'Portada'}<input type="file" accept="image/*" onChange={onCover} style={{ display: 'none' }} /></label>
        <button className="lb-btn lb-btn--primary lb-btn--sm" style={{ gridColumn: '1 / -1', justifySelf: 'start' }} onClick={create}>+ Crear álbum</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px,1fr))', gap: 16 }}>
        {albums.map(a => (
          <div key={a.id} className="lb-card" style={{ overflow: 'hidden', opacity: a.visible ? 1 : 0.5 }}>
            <div style={{ aspectRatio: '16/9', background: a.cover_url ? `center/cover no-repeat url(${a.cover_url})` : 'var(--ink-200)' }} />
            <div style={{ padding: '12px 14px' }}>
              <div style={{ fontSize: 11, color: INK, textTransform: 'capitalize' }}>{fmtDate(a.date)}</div>
              <div style={{ color: '#fff', fontWeight: 600, marginTop: 2 }}>{a.title}</div>
              <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setEditing(a)}>Editar</button>
                <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => toggle(a)}>{a.visible ? 'Ocultar' : 'Mostrar'}</button>
                <button className="lb-iconbtn" onClick={() => rm(a.id)}>✕</button>
              </div>
            </div>
          </div>
        ))}
        {albums.length === 0 && <div style={{ color: INK, fontSize: 13 }}>Sin álbumes todavía.</div>}
      </div>

      {editing && <EditModal api={api} album={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </div>
  );
}

function EditModal({ api, album, onClose, onSaved }) {
  const [f, setF] = useState({
    title: album.title || '',
    date: album.date ? String(album.date).slice(0, 10) : '',
    drive_link: album.drive_link || '',
    cover_url: album.cover_url || null,
  });
  const [saving, setSaving] = useState(false);

  const onCover = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    try { const url = await resizeImage(file, 1000, 0.8); setF(s => ({ ...s, cover_url: url })); } catch (err) { alert(err.message); }
  };
  async function save() {
    if (!f.title.trim()) { alert('Poné un título'); return; }
    setSaving(true);
    try { await api.patch(`/api/gallery/${album.id}`, f); onSaved(); }
    catch (e) { alert(e.message); } finally { setSaving(false); }
  }

  return (
    <div className="lb-modal-backdrop" onClick={onClose}>
      <div className="lb-modal" onClick={e => e.stopPropagation()}>
        <div style={{ padding: '24px 28px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div className="lb-eyebrow">Editar álbum</div>
            <div className="lb-h" style={{ fontSize: 20, marginTop: 4 }}>{f.title || 'Sin título'}</div>
          </div>
          <button className="lb-iconbtn" onClick={onClose}>✕</button>
        </div>
        <div style={{ padding: '24px 28px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Field label="Título"><input className="lb-input" value={f.title} onChange={e => setF({ ...f, title: e.target.value })} /></Field>
          <Field label="Fecha"><input className="lb-input" type="date" value={f.date} onChange={e => setF({ ...f, date: e.target.value })} /></Field>
          <Field label="Link de Google Drive"><input className="lb-input" value={f.drive_link} onChange={e => setF({ ...f, drive_link: e.target.value })} placeholder="https://drive.google.com/…" /></Field>
          <Field label="Portada">
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ width: 80, height: 45, borderRadius: 4, background: f.cover_url ? `center/cover no-repeat url(${f.cover_url})` : 'var(--ink-200)', border: '1px solid var(--border)', flex: 'none' }} />
              <label className="lb-btn lb-btn--ghost lb-btn--sm" style={{ cursor: 'pointer' }}>{f.cover_url ? 'Cambiar portada' : 'Subir portada'}<input type="file" accept="image/*" onChange={onCover} style={{ display: 'none' }} /></label>
            </div>
          </Field>
        </div>
        <div style={{ padding: '18px 28px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={onClose}>Cancelar</button>
          <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={save} disabled={saving}>{saving ? 'Guardando…' : 'Guardar cambios'}</button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) { return <div className="lb-field"><div className="lb-label">{label}</div>{children}</div>; }
